import {
  Table,
  TableBody,
  TableHead,
  Button,
  Typography,
  makeStyles,
  Tooltip,
} from '@material-ui/core'
import React from 'react'
import { Info } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { SidebarAccordionTableRow } from '../common/SidebarAccordionTableRow'

type RowData = {
  name: string
  value: string | number
  tooltip?: string
}
type Props = {
  header: string
  rowsData: RowData[]
  onStartEdit?: () => void
}

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.grey[500],
    padding: 0,
    fontSize: 16,
  },
}))

export function PricingModelTable({
  header,
  rowsData,
  onStartEdit,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const classes = useStyles()

  const rowToName = (row: RowData) => (
    <>
      {row.name}
      {row.tooltip && (
        <Tooltip title={row.tooltip} placement="right">
          <Info size={16} />
        </Tooltip>
      )}
    </>
  )

  return (
    <Table>
      <TableHead>
        <SidebarAccordionTableRow
          name={<Typography variant="subtitle1">{header}</Typography>}
          value={
            onStartEdit ? (
              <Button className={classes.button} onClick={onStartEdit}>
                {t('common.edit')}
              </Button>
            ) : (
              <></>
            )
          }
          showBorder
        />
      </TableHead>
      <TableBody>
        {rowsData.map((row) => (
          <SidebarAccordionTableRow
            key={row.name}
            name={rowToName(row)}
            value={row.value}
          />
        ))}
      </TableBody>
    </Table>
  )
}
